export default __webpack_public_path__ + "static/media/Apple_logo_black.svg.a612b13e.png";